import { Avatar, Box, Skeleton, Typography } from '@mui/material';
import { useOtherConsultants } from 'dashboard409a/hooks/useOtherConsultants';
import { getInitials } from 'utilities';
import { OtherConsultantCellProps } from './cells.props';
import { PersonSearchPopover } from './personSearchPopover';

const ConsultantCell = ({ valuationRow, onOtherConsultantsUpdate }: OtherConsultantCellProps) => {
  const {
    anchorEl,
    searchTerm,
    searching,
    consultants,
    selectedConsultants,
    open,
    popoverId,
    handleClick,
    handleClose,
    handleToggleConsultant,
    handleSave,
    handleSearch,
    handleKeyDown,
    setSearchTerm,
  } = useOtherConsultants({ valuationRow, onOtherConsultantsUpdate });

  if (valuationRow.is_loading_additional_data) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Skeleton variant="circular" width={28} height={28} />
        <Box>
          <Skeleton variant="text" width={120} height={20} />
        </Box>
      </Box>
    );
  }

  const displayContent =
    valuationRow.other_consultant && valuationRow.other_consultant !== '-' ? (
      <Box
        onClick={handleClick}
        sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}>
        <Avatar
          alt={valuationRow.other_consultant}
          src={
            valuationRow.other_consultant_image_src && valuationRow.other_consultant_image_src !== '-'
              ? valuationRow.other_consultant_image_src
              : undefined
          }
          sx={{ width: 28, height: 28, fontSize: '0.75rem' }}>
          {getInitials({ name: valuationRow.other_consultant[0] })}
        </Avatar>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
            {valuationRow.other_consultant[0]}
          </Typography>
        </Box>
      </Box>
    ) : (
      <Box onClick={handleClick} sx={{ cursor: 'pointer', '&:hover': { opacity: 0.8 } }}>
        <Typography variant="body2" color="text.secondary">
          -
        </Typography>
      </Box>
    );

  const results = consultants.map(consultant => ({
    ...consultant,
    targetRecordId: (consultant as unknown as { targetRecordId?: string }).targetRecordId || '',
  }));

  return (
    <>
      {displayContent}
      <PersonSearchPopover
        open={open}
        anchorEl={anchorEl}
        popoverId={popoverId}
        onClose={handleClose}
        searchTerm={searchTerm}
        onSearchTermChange={setSearchTerm}
        searching={searching}
        onSearch={handleSearch}
        onKeyDown={handleKeyDown}
        results={results}
        selectionMode="multi"
        selectedTeamMembers={selectedConsultants || []}
        onToggleSelection={handleToggleConsultant}
        onSave={handleSave}
        placeholder="Search for other consultants..."
        helpText="Search and select consultants."
        minWidth={320}
      />
    </>
  );
};

export default ConsultantCell;
